import { render, staticRenderFns } from "./btn-properties.vue?vue&type=template&id=41e1a6ba&scoped=true"
import script from "./btn-properties.vue?vue&type=script&lang=js"
export * from "./btn-properties.vue?vue&type=script&lang=js"
import style0 from "./btn-properties.vue?vue&type=style&index=0&id=41e1a6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1a6ba",
  null
  
)

export default component.exports